module.exports = __webpack_public_path__ + "img/metal_au@2x.8186f229.png";